export default "__VITE_ASSET__CKE8OuP8__"